module.exports = __webpack_public_path__ + "img/logo_hexa.371995bc.png";